// Source: Chakra Breakpoints (https://chakra-ui.com/docs/features/responsive-styles)
export const smallScreen = '30em'
export const medScreen = '48em'
export const largeScreen = '62em'
export const almostLargeScreen = '61.999em'
export const xlScreen = '80em'
export const twoXLScreen = '96em'
export const breakpoints = [smallScreen, medScreen, largeScreen, xlScreen, twoXLScreen]
